import {PUBLISHING_SETTING} from '../../../CodeMaster'
import {Nullable} from '../../../app/TypeHelpers'

export class AssocOfCondominium {
    assocId: number
    assocCd: string
    assocName: string
    parentAssocId: Nullable<number>
    reportPublishingSetting: PUBLISHING_SETTING
    version: number

    constructor(params: {
        assocId: number,
        assocCd: string,
        assocName: string,
        parentAssocId: Nullable<number>,
        reportPublishingSetting: PUBLISHING_SETTING,
        version: number,
    }) {
        this.assocId = params.assocId
        this.assocCd = params.assocCd
        this.assocName = params.assocName
        this.parentAssocId = params.parentAssocId
        this.reportPublishingSetting = params.reportPublishingSetting
        this.version = params.version
    }

    static from(json: any): AssocOfCondominium {
        return new AssocOfCondominium({
            assocId: json.assocId,
            assocCd: json.assocCd,
            assocName: json.assocName,
            parentAssocId: json.parentAssocId,
            reportPublishingSetting: PUBLISHING_SETTING.codeToEnumConstants(json.reportPublishingSetting),
            version: json.version,
        })
    }

    toObject(): object {
        return {
            assocId: this.assocId,
            assocCd: this.assocCd,
            assocName: this.assocName,
            parentAssocId: this.parentAssocId,
            reportPublishingSetting: this.reportPublishingSetting.value,
            version: this.version,
        }
    }
}

